import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({ providedIn: "root" })
export class LoaderService {
  private requestsAmount = 0;

  constructor(private readonly ngxSpinner: NgxSpinnerService) {}

  pushRequest(): void {
    this.requestsAmount += 1;

    if (this.requestsAmount === 1) {
      this.ngxSpinner.show();
    }
  }

  removeRequest(): void {
    this.requestsAmount -= 1;
    if (this.requestsAmount < 0) {
      this.requestsAmount = 0;
    }

    if (this.requestsAmount === 0) {
      setTimeout(() => {
        this.ngxSpinner.hide();
      }, 1000);
    }
  }
}
